import { createPortal } from "react-dom";
import {
  PlaceSearchInput,
  type PlaceSuggestion,
} from "@/modules/places/PlaceSearchInput";

interface AddPlacePortalProps {
  onClose: () => void;
  onPlaceSelected: (s: PlaceSuggestion) => void;
}

/**
 * The "Add a Place" modal, portaled to document.body.
 *
 * Lifted verbatim from PlaceListModule's `isAddingPlace && createPortal(...)`
 * root-level modal (hoisted so it works from any view). The `isAddingPlace`
 * render guard stays in the orchestrator; this leaf just renders the search
 * input + close affordances and fires the two callbacks.
 */
export function AddPlacePortal({ onClose, onPlaceSelected }: AddPlacePortalProps) {
  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.3)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: "20vh",
        zIndex: 10000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "var(--color-surface)",
          borderRadius: 12,
          padding: 20,
          width: 380,
          maxWidth: "90vw",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 600,
            marginBottom: 12,
            color: "var(--color-text)",
          }}
        >
          Add a Place
        </div>
        <PlaceSearchInput
          placeholder="Search for a place..."
          onPlaceSelected={(s) => {
            onPlaceSelected(s);
            onClose();
          }}
          className="place-search"
          showZipCode={false}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 12,
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "6px 16px",
              borderRadius: 6,
              border: "1px solid #e5e7eb",
              background: "var(--color-surface)",
              fontSize: 13,
              cursor: "pointer",
              color: "var(--color-text-muted)",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
